import { useLocale, useTranslations } from "next-intl";

import type { Product } from "resources/types";

import { usePrice } from "./usePrice";

export function useTeaserA11y(product: Product) {
  const locale = useLocale();
  const t = useTranslations("teaser");
  const { isAvailableInSubscription, isCycle, finalPrice, basePrice, lowestPrice } = usePrice(product);
  const ratingFormat = new Intl.NumberFormat(locale, { minimumFractionDigits: 1, maximumFractionDigits: 1 });

  return [
    product.name,
    product.description,
    isCycle && t("cycle"),
    product.rating && product.rating > 0 && t("rating", { rating: ratingFormat.format(product.rating) }),
    isAvailableInSubscription && t("club_badge"),
    finalPrice &&
      (finalPrice === basePrice
        ? t("price.base_price", { finalPrice })
        : t("price.discount_price", { finalPrice, basePrice: basePrice! })),
    lowestPrice && t("price.lowest_price", { lowestPrice }),
  ]
    .filter(Boolean)
    .join(". ");
}
